import { render, staticRenderFns } from "./TitleAndDescription.vue?vue&type=template&id=05585f6e"
import script from "./TitleAndDescription.vue?vue&type=script&lang=js"
export * from "./TitleAndDescription.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports